var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stash:chart-trend-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9532 7.77199C14.9532 7.49165 15.0646 7.22279 15.2628 7.02456C15.461 6.82633 15.7299 6.71497 16.0102 6.71497H20.943C21.2233 6.71497 21.4922 6.82633 21.6904 7.02456C21.8886 7.22279 22 7.49165 22 7.77199V12.7047C22 12.9851 21.8886 13.2539 21.6904 13.4522C21.4922 13.6504 21.2233 13.7618 20.943 13.7618C20.6626 13.7618 20.3938 13.6504 20.1956 13.4522C19.9973 13.2539 19.886 12.9851 19.886 12.7047V10.3229L13.2338 16.9751C13.0356 17.1731 12.7669 17.2842 12.4868 17.2842C12.2067 17.2842 11.938 17.1731 11.7399 16.9751L8.25874 13.494L4.77762 16.9751C4.57724 17.1618 4.31221 17.2635 4.03837 17.2586C3.76453 17.2538 3.50326 17.1429 3.30959 16.9492C3.11593 16.7555 3.005 16.4943 3.00016 16.2204C2.99533 15.9466 3.09698 15.6816 3.28369 15.4812L7.51177 11.2531C7.70997 11.0552 7.97862 10.944 8.25874 10.944C8.53885 10.944 8.8075 11.0552 9.0057 11.2531L12.4868 14.7342L18.392 8.82901H16.0102C15.7299 8.82901 15.461 8.71764 15.2628 8.51941C15.0646 8.32118 14.9532 8.05233 14.9532 7.77199Z",
    fill: "#15318D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE3);
export default __webpack_public_path__ + "static/media/e3.0499e23a7136c3aefddd16c036fe67d5.svg";
export { ForwardRef as ReactComponent };